
import { css } from 'lit';
export default css`
.cta-buttons {padding-top: 1.5rem;padding-bottom: 1.5rem
}@media (min-width: 768px) {.cta-buttons {border-bottom-width: 1px
  }.cta-buttons {--tw-border-opacity: 1;border-color: rgba(216, 216, 216, var(--tw-border-opacity))
  }
}@media (min-width: 1024px) {.cta-buttons {padding-top: 2rem;padding-bottom: 2rem
  }
}.cta-buttons__list {display: flex
}.cta-buttons__list {flex-direction: column
}@media (min-width: 768px) {.cta-buttons__list {display: flex
  }
}@media (min-width: 768px) {.cta-buttons__list {flex: none
  }
}@media (min-width: 768px) {.cta-buttons__list {flex-direction: row
  }
}@media (min-width: 768px) {.cta-buttons__list {flex-wrap: wrap
  }
}@media (min-width: 768px) {.cta-buttons__list {justify-content: flex-start
  }
}.cta-buttons__item {margin-bottom: 1rem
}@media (min-width: 768px) {.cta-buttons__item {margin-right: 0.75rem
  }
}@media (min-width: 768px) {.cta-buttons__item {margin-bottom: 0px
  }
}@media (min-width: 1024px) {.cta-buttons__item {margin-right: 1.25rem
  }
}.cta-buttons__item:last-child {margin-right: 0px
}
`;